import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { useEditUserNameMutation } from "../../../../store/Apis/UserApi";
import { nameRegex } from "../../../../Helper";
import { setUpdateUserName } from "../../../../store/account/userSlice";
import "./PopupEditName.css";
import {validateName} from "../../../../validateNameHelper";
interface EditNameProps {
  show: boolean;
  handleClosePopUp: () => void;
}
interface DataProfileInterface {
  firstName: string;
  lastName: string;
}
const PopupEditName = ({ show, handleClosePopUp }: EditNameProps) => {
    const dispatch=useAppDispatch();
  const user = useAppSelector((s) => s.User);
  const [userName, setUserName] = useState<DataProfileInterface>({
    firstName: "",
    lastName: "",
  });
  const [validationErrorStateFirstName, setValidationErrorStateFirstName] =
    useState<string>("");
  const [validationErrorStateLastName, setValidationErrorStateLastName] =
    useState<string>("");
  const inputRef = useRef<HTMLInputElement>(null);
  const updateUserName = useEditUserNameMutation();

  useEffect(() => {
    if (show && inputRef.current) {
      inputRef.current.focus();
    }
  }, [show]);
  useEffect(() => {
    if (user?.userData)
      setUserName({
        firstName: user?.userData?.firstName,
        lastName: user?.userData?.lastName,
      });
  }, [user.userData]);

  useEffect(() => {
    // this validation for first name
    const checkFirstNameResult = validateName(userName.firstName,"first"); 
      setValidationErrorStateFirstName(checkFirstNameResult);

    // this validation for last name 
    const checkLastNameResult = validateName(userName.lastName,"last");
      setValidationErrorStateLastName(checkLastNameResult);
  }, [userName]);

  const handleUserName = (e:React.ChangeEvent<HTMLInputElement>) => {
    setUserName((oldData) => ({
      ...oldData,
      [e.target.name]: e.target.value,
    }));
  };
   const handleUpdateUserName = () => {
     if (user.userData?.id) {
       updateUserName(
         user.userData?.id,
         userName?.firstName,
         userName?.lastName
       );
     }
   };
  const handleSavePicture = () => {
    if (
      nameRegex.test(userName.firstName.trim()) &&
      nameRegex.test(userName.lastName.trim())
    ) {
      handleUpdateUserName();
      dispatch(
        setUpdateUserName({
          firstName: userName?.firstName.trim(),
          lastName: userName?.lastName.trim(),
        })
      );
      handleClosePopUp();
    }
  };
  return (
    <Modal className="EditNamePopup" show={show} centered>
      <Modal.Header className="EditNamePopupHeader border-0 rounded-top-4">
        <Modal.Title className="EidtNamePopupHeader ps-2">
          Update full name
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className={`EditNameModalBody border-0 px-2 rounded-bottom-4`}
      >
        <div>
          <div className="user_name row d-flex">
            <div className="col-5 p-1 pb-0 ms-1" style={{ height: "80px" }}>
              <input
                className={`inputStyle name-style w-100 `}
                type="text"
                value={userName?.firstName}
                name="firstName"
                onChange={(e) => handleUserName(e)}
                ref={inputRef}
              />
              {validationErrorStateFirstName?.length > 0 && (
                <p className="ErrorStyleForName">
                  {validationErrorStateFirstName}
                </p>
              )}
            </div>
            <div className="col-5 p-1 pb-0 ms-1" style={{ height: "80px" }}>
              <input
                className={`inputStyle name-style w-100 `}
                type="text"
                value={userName?.lastName}
                name="lastName"
                onChange={(e) => handleUserName(e)}
              />
              {validationErrorStateLastName?.length > 0 && (
                <p className="ErrorStyleForName">
                  {validationErrorStateLastName}
                </p>
              )}
            </div>
          </div>
          <div className="containerButtonsEditName mt-4 me-4 mb-3">
            <button
              className="cancel-btn-profile-picture btn-Edit-Name"
              onClick={handleClosePopUp}
            >
              Cancel
            </button>
            <button
              className="save-btn-profile-picture ms-4 btn-Edit-Name"
              onClick={handleSavePicture}
            >
              Update
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PopupEditName;
